export default "__VITE_PUBLIC_ASSET__44c1f920__"